export default [
    {
        path: '/admin/fixed-incentive-bonus',
        name: "fixed-incentive-bonus",
        meta: { requiresAuth: true },
        component: () => import("@/pages/payroll/fixed-incentive-bonus/index.vue")
    }
]